module.exports = __webpack_public_path__ + "static/assets/48ed62bb2875adc2cf9739588bb16c4b.png";